import type { TSearchParamsScope } from '~/types/search-params'

/**
 * It pairs a scope (section or view) with the search param keys it uses
 */
export const SEARCH_PARAMS_KEYS: { [key in TSearchParamsScope]: { KEYS: string[]; PATHNAME_PREFIXES: string[] } } = {
  ACCOUNTS: {
    KEYS: ['search'],
    PATHNAME_PREFIXES: ['/accounts'],
  },
  APP: {
    KEYS: ['app'],
    PATHNAME_PREFIXES: [
      '/analytics/ca',
      '/analytics/business-report',
      '/app-config',
      '/compare-cohorts',
      '/aso',
      '/dynamic-screens/arbitration',
      '/checklists',
      '/events',
      '/external-links',
      '/in-app-purchases/features',
      '/in-app-purchases/feature-groups',
      '/in-app-purchases/graph',
      '/in-app-purchases/products',
      '/in-app-purchases/subscriptions',
      '/reports',
      '/summary',
      '/todolists',
      '/versions',
    ],
  },
  ASO_ADVANCED: {
    KEYS: ['country'],
    PATHNAME_PREFIXES: ['/aso/advanced'],
  },
  BUSINESS_REPORTS: {
    KEYS: [
      'allExceptCountry',
      'allExceptSource',
      'appKey',
      'campaign',
      'country',
      'deviceType',
      'endDate',
      'source',
      'startDate',
    ],
    PATHNAME_PREFIXES: ['/analytics/business-report'],
  },
  CLUSTER_COMPETITORS: {
    KEYS: ['tags[]', 'listingMode', 'deviceType', 'searchElements[]', 'filterPreset'],
    PATHNAME_PREFIXES: ['/competitors/clusters'],
  },
  COHORTED_ANALYTICS: {
    KEYS: [
      'abtestKey',
      'breakdown',
      'dai',
      'deviceCategory',
      'endDate',
      'installationAppVersion',
      'installationCountry',
      'kpi',
      'navigationGraphId',
      'placementKey',
      'uaSource',
      'userType',
      'startDate',
    ],
    PATHNAME_PREFIXES: ['/analytics/ca'],
  },
  GLOSSARY: {
    KEYS: ['search'],
    PATHNAME_PREFIXES: ['/glossary'],
  },
  IAP_LISTING: {
    KEYS: ['apps', 'appsUnlocked', 'features', 'freeTrial', 'period', 'priceRange', 'skus', 'type'],
    PATHNAME_PREFIXES: ['/in-app-purchases/in-apps', '/in-app-purchases/offers'],
  },
  REVIEWS_MONITORING: {
    KEYS: [
      'apps[]',
      'appVersions[]',
      'end',
      'countries[]',
      'languages[]',
      'mlLabels[]',
      'ratings[]',
      'start',
      'statuses[]',
      'tags[]',
      'topics[]',
    ],
    PATHNAME_PREFIXES: ['/reviews/monitoring'],
  },
  UA_MANAGEMENT: {
    KEYS: [
      'adSetNames[]',
      'appKeys[]',
      'campaignNames[]',
      'countries[]',
      'deviceType',
      'end',
      'hideTreatedReco',
      'networks[]',
      'start',
    ],
    PATHNAME_PREFIXES: ['/ua-management'],
  },
  VERSIONS: {
    KEYS: ['externalId'],
    PATHNAME_PREFIXES: ['/versions'],
  },
}
